"use client";

import React from "react";
import { ArrowRight, ZoomIn } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryItems = [{
  title: "Modern Industristil",
  description: "En tidlös kombination av mörka stenskivor och detaljer i borstad mässing.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/wet_room_modern_slate.png",
  alt: "Modern badrumsdesign med mörka stenskivor"
}, {
  title: "Minimalistisk Elegans",
  description: "Svala grå toner och rena linjer skapar en harmonisk och rofylld atmosfär.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/walk_in_shower_glass_partition.png",
  alt: "Minimalistiskt badrum med glasvägg"
}, {
  title: "Lyxig Marmorkänsla",
  description: "Exklusivt badrum med helkaklad marmor för en sofistikerad hotellkänsla i hemmet.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/luxury_wet_room_marble.png",
  alt: "Lyxigt badrum med marmorkakel"
}, {
  title: "Funktionell Design",
  description: "Stilren walk-in shower som kombinerar hög tillgänglighet med modern estetik.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/accessible_walk_in_shower_seat.png",
  alt: "Funktionell och stilren duschlösning"
}, {
  title: "Betong & Karaktär",
  description: "Industriell design med polerad betongyta och kontrasterande svarta detaljer.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/minimalist_wet_room_concrete.png",
  alt: "Industriellt badrum med betongkänsla"
}, {
  title: "Effektivt & Stilrent",
  description: "Smart planering och noggrann plattsättning som förvandlar mindre ytor till ett lyxigt och rymligt badrum.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/small_bathroom_wet_room_conversion.png",
  alt: "Renovering av litet badrum till våtrum"
}];
export default function WetRoomsWalkInShowersGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="56530" id="inspirationsgalleri" className="bg-background text-foreground py-16 sm:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`mx-auto max-w-2xl text-center transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="text-foreground text-3xl font-default font-semibold tracking-tight sm:text-5xl">Badrumsinspiration – Utforska stilar och idéer</h2>
          <p className="text-muted-foreground mt-6 text-lg font-default leading-relaxed">Låt dig inspireras av olika badrumsstilar, från stilren minimalism till moderna material och eleganta detaljer. Utforska vårt galleri och hitta idéer för färger, inredning och smarta lösningar som passar just ditt badrum.</p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {galleryItems.map((item, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-[${i * 100}ms] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
              <Card className="group h-full overflow-hidden border-border bg-card transition-all hover:shadow-md hover:border-primary/20">
                <div className="relative aspect-[4/3] overflow-hidden bg-muted">
                  <img src={item.image} alt={item.alt} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 flex items-center justify-center bg-black/0 transition-colors duration-300 group-hover:bg-black/10">
                    <ZoomIn className="text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                  </div>
                </div>
                <CardHeader>
                  <CardTitle className="text-xl font-default font-semibold text-foreground">{item.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base font-default text-muted-foreground">
                    {item.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className={`mt-16 flex justify-center transition-all duration-700 delay-500 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <Button asChild size="lg" className="rounded-md px-8 bg-primary text-primary-foreground font-semibold transition-transform hover:scale-[1.02]">
            <Link to="/QuoteRequestPage">
              Begär kostnadsfri offert <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}